import MediaGallery from "@/components/MediaGallery";
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';

const CarouselModal = forwardRef((props, ref) => {
    const {refs, media, methods, actions} = props || {};
    
    const [visible, setVisiblity] = useState(false);
    const mediaGalleryRef = useRef(null);

    const handleClose = () => {
        if (refs?.activeIndexRef && methods?.setActiveIndex) {
            methods?.setActiveIndex(refs?.activeIndexRef?.current);
        }
        setVisiblity(false);
    }

    const handleOpen = (index) => {
        mediaGalleryRef?.current?.open(refs?.activeIndexRef?.current ?? index ?? 0);
    }

    useImperativeHandle(ref, () => ({
        open: (index) => handleOpen(index),
        close: () => handleClose()
    }), []);

    const handleUpdateIndex = (index) => {
        if (methods?.setActiveIndex) {
            methods?.setActiveIndex(index);
        }
    }

    if (media?.length === 0) 
        return (<></>);
    

    return (
        <MediaGallery
            ref={mediaGalleryRef}
            imageIndex={refs?.activeIndexRef?.current ?? 0}
            visible={visible}
            actions={actions}
            onImageIndexChange={handleUpdateIndex} 
            media={media}

        />
    );
});

export default CarouselModal;